// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"MiniContentCard_wrapper__lbT9d","content":"MiniContentCard_content__DFMGx","free-badge":"MiniContentCard_free-badge__MjXwm"};